import React, { useEffect, useState } from 'react'
import Notification from '../Utils/Notification'
import { SUCCESS } from '../../utils/constants'
import { withAuth } from '../AuthContext'
import { withSearch } from '../SearchContext'
import { withRouter } from 'react-router-dom'
import { gaEvents } from '../../analytics/events'
import { shouldTranslateTo } from '../../utils/utils'
import { useStateWithCallbackLazy } from 'use-state-with-callback'
import Error from '../Utils/Error'
import styled from 'styled-components'

import {
  Title,
  CustomSubtitle,
  ActionButtons,
  Input,
  LoadingButton,
  FormSelect,
  TextArea,
  CheckboxDiv,
  Checkbox,
  CheckboxWrapper,
  CustomCheckbox,
  CustomSelect,
} from '../Utils/CustomClasses'

const ContainerBox = styled.div`
  padding: 30px 36px 55px 36px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const FormContent = styled.div`
  margin-top: 50px;
  display: flex;

  button {
    width: 30vw;
    min-width: 250px;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`

const ErrorWrapper = styled.div`
  margin: 20px 0 0 0;
  padding: 0;

  > div {
    padding: 0;
    > label {
      margin: 0 !important;
    }
  }
`

const CustomCheckboxWrapper = styled(CheckboxWrapper)`
  margin-top: 0;
  margin-bottom: 30px;
`

const CustomCheckboxForm = styled(CustomCheckbox)`
  border: 2px solid rgba(17, 17, 19, 0.39);
  border-radius: 50%;
  margin-left: 6px;
  height: 30px;
  width: 30px;
`

const CustomInput = styled(Input)`
  height: 50px;
`

const EditProfileApp = ({ data, countriesNice, onUpdate }) => {
  const [languagesOptions, setLanguagesOptions] = useState([])
  const [defaultLanguages, setDefaultLanguages] = useState([])
  const [languages, setLanguages] = useState([])
  const [languagesError, setLanguagesError] = useState(false)
  const [introduction, setIntroduction] = useState('')
  const [introductionError, setIntroductionError] = useState(false)
  const [interest, setInterest] = useState('')
  const [interestError, setInterestError] = useState(false)
  const [country, setCountry] = React.useState('')
  const [countrySelected, setCountrySelected] = React.useState({})
  const [citySelect, setCitySelect] = React.useState('')
  const [cityInput, setCityInput] = React.useState('')
  const [isNewCity, setIsNewCity] = React.useState(false)
  const [cities, setCities] = useStateWithCallbackLazy([])
  const [genderPreference, setGenderPreference] = useState('')
  const [countryError, setCountryError] = React.useState(false)
  const [cityError, setCityError] = React.useState(false)
  const [genderPreferenceError, setGenderPreferenceError] = useState(false)
  const [loading, setLoading] = useState('')
  const [error, setError] = useState('')
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'edit-profile-stage1-loaded',
      data.auth.user.id + ' - edit profiel stage 1 - page loaded'
    )

    axios
      .get('/api/languages-all')
      .then((res) => {
        const languagesOptionsData = res.data.map(function (language) {
          return { label: language.name, value: language.id }
        })
        setLanguagesOptions(languagesOptionsData)
      })
      .catch((e) => {
        console.log(e)
      })

    const user = data.auth.user
    const userLanguages = user.languages

    if (user.countryId) {
      setCountrySelected(countriesNice.find((c) => c.value === user.countryId))
      setCountry(user.countryId)
      getCities(user)
      if (user.isNewCity) {
        setIsNewCity(user.isNewCity)
        setCityInput(user.city)
      }
    }

    setLanguages(
      userLanguages &&
        userLanguages.map(function (language) {
          return language.id
        })
    )
    setDefaultLanguages(
      userLanguages &&
        userLanguages.map(function (language) {
          return { label: language.name, value: language.id }
        })
    )
    setIntroduction(user.introduction)
    setInterest(user.interest)
    setGenderPreference(user.genderPreference)

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          pageValue === 'profile-information'
            ? setPageText(pageText)
            : setPageText2(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('profile-information', language)
    getPageText('signup-app', language)
  }, [])

  const handleInputChange = (e) => {
    const target = e.target
    const name = target.name
    setError('')
    setIntroductionError(false)
    setInterestError(false)
    setGenderPreferenceError(false)
    setLanguagesError(false)
    switch (name) {
      case 'introduction':
        setIntroduction(e.target.value)
        break
      case 'interest':
        setInterest(e.target.value)
        break
      default:
        break
    }
  }

  const updateCountry = async ({ value }) => {
    setCitySelect('')
    setCityInput('')
    setCountryError(false)
    setError(null)
    setCountry(value)
    setCountrySelected(countriesNice.find((c) => c.value === value))
    let citiesResult = await returnCitiesList(value)
    setCities(citiesResult)
  }

  const getCities = async (user) => {
    let citiesResult = await returnCitiesList(user.countryId)
    setCities(citiesResult)
    if (user.locationId) {
      const selectedCity = citiesResult.find(
        (city) => city.value === user.locationId
      )
      setCityInput(selectedCity.label)
      setCitySelect(selectedCity.value)
    }
  }

  const returnCitiesList = async (value) => {
    try {
      const response = await axios.get(`/api/cities/${value}`)
      let citiesList = response.data.map((city) => {
        return { label: city.city, value: city.id }
      })
      return citiesList
    } catch (e) {
      console.log('Error getting cities: ', e)
    }
  }

  const { search } = data

  const updateCity = (e) => {
    setCityError(false)
    setError(null)
    if (isNewCity) {
      setCityInput(e)
    } else {
      setCityInput(e.label)
      setCitySelect(e.value)
    }
  }

  const updateIsNewCity = (e) => {
    setError(null)
    setCityInput('')
    setCitySelect(0)
    if (isNewCity) {
      setIsNewCity(false)
    } else {
      setIsNewCity(true)
    }
  }

  const handleGenderPreferenceChange = (e) => {
    setError('')
    setIntroductionError(false)
    setInterestError(false)
    setGenderPreferenceError(false)
    setLanguagesError(false)
    setGenderPreference(e.target.value)
  }

  const handleDivGenderPreferenceChange = (value) => {
    setError('')
    setIntroductionError(false)
    setInterestError(false)
    setGenderPreferenceError(false)
    setLanguagesError(false)
    setGenderPreference(value)
  }

  const handleLanguageChange = (option) => {
    setError('')
    setIntroductionError(false)
    setInterestError(false)
    setGenderPreferenceError(false)
    setLanguagesError(false)
    const languagesData = option.map(function (option) {
      return option.value
    })
    setLanguages(languagesData)
    setDefaultLanguages(languagesData)
  }

  const handleSubmit = (e) => {
    gaEvents.eventGeneric(
      'form_submit',
      'submitted',
      'Edit profile stage 1 submitted'
    )

    e.preventDefault()

    if (!introduction) {
      setIntroductionError(true)
      setError(`${pageText[45]}`)
      return
    } else if (!interest) {
      setInterstError(true)
      setError('Please complete the interests field before proceeding')
      return
    } else if (!genderPreference) {
      setGenderPreferenceError(true)
      setError(`${pageText[46]}`)
      return
    } else if (languages.length < 1) {
      setLanguagesError(true)
      setError(`${pageText[47]}`)
      return
    }

    // Validate country
    if (!country) {
      setCountryError(true)
      setError(pageText2[47])
      return
    }

    // Validate city
    if (isNewCity) {
      if (!cityInput) {
        setCityError(true)
        setError(pageText2[48])
        return
      }
    } else {
      if (!citySelect) {
        setCityError(true)
        setError(pageText2[49])
        return
      }
    }

    setLoading(true)

    const userData = {
      introduction: introduction,
      interest: interest,
      genderPreference: genderPreference,
      languages: languages,
      introductionStatus: 'completed',
      interestStatus: 'completed',
      countryId: country,
      locationId: isNewCity ? null : citySelect,
      city: cityInput,
      isNewCity: isNewCity,
    }

    data.auth
      .updateUser(userData)
      .then(() => {
        Notification({
          type: SUCCESS,
          message: `${pageText[48]}`,
        })

        data.auth.refreshUser()

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        setTimeout(function () {
          onUpdate()
        }, 1000)

        setLoading(false)
      })
      .catch((e) => {
        Notification({
          data: e,
        })
        setLoading(false)
      })
  }

  if (pageText.length === 0 || languagesOptions.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[49]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      <Title
        size="29px"
        sizemd="29px"
        sizesm="24px"
        margin="0"
        dangerouslySetInnerHTML={{
          __html: `${pageText[1]}`,
        }}
      ></Title>

      <form
        method="POST"
        action="/"
        name="myForm"
        aria-label="Add Profile"
        onSubmit={(e) => handleSubmit(e)}
      >
        <input
          type="hidden"
          name="csrf-token"
          value={window.Laravel.csrfToken}
        />

        {/* INTRODUCE YORSELF */}
        <CustomSubtitle
          bold
          size="22px"
          margin="0 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[2]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 16px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[3]}`,
          }}
        />
        <TextArea
          id="introduction"
          name="introduction"
          className={introductionError && 'error-border'}
          rows="5"
          required
          placeholder={pageText[32]}
          value={introduction}
          onChange={(e) => handleInputChange(e)}
        />

        {/* Interests */}
        <CustomSubtitle
          bold
          size="22px"
          margin="30px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[4]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 16px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[5]}`,
          }}
        />
        <TextArea
          id="interest"
          name="interest"
          rows="5"
          placeholder={pageText[33]}
          required
          value={interest}
          onChange={(e) => handleInputChange(e)}
        />

        {/* I WANT TO BE CONTACTED BY */}
        <CustomSubtitle
          bold
          size="22px"
          margin="35px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[9]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 16px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[10]}`,
          }}
        />

        <CheckboxDiv
          className={
            genderPreference === 'any'
              ? 'checked'
              : genderPreferenceError
                ? 'error-border'
                : ''
          }
          onClick={() => handleDivGenderPreferenceChange('any')}
        >
          <Checkbox
            type="radio"
            name="genderPreference"
            id="genderPreference-any"
            className={genderPreference === 'any' && 'checked'}
            value={'any'}
            checked={genderPreference === 'any'}
            onChange={(e) => handleGenderPreferenceChange(e)}
          />
          <CustomSubtitle
            bold={genderPreference === 'any'}
            size="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[20]}`,
            }}
          />
        </CheckboxDiv>

        <CheckboxDiv
          className={
            genderPreference === 'womenonly'
              ? 'checked'
              : genderPreferenceError
                ? 'error-border'
                : ''
          }
          onClick={() => handleDivGenderPreferenceChange('womenonly')}
        >
          <Checkbox
            type="radio"
            name="genderPreference"
            id="genderPreference-womenonly"
            className={genderPreference === 'womenonly' && 'checked'}
            value={'womenonly'}
            checked={genderPreference === 'womenonly'}
            onChange={(e) => handleGenderPreferenceChange(e)}
          />
          <CustomSubtitle
            bold={genderPreference === 'womenonly'}
            size="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[21]}`,
            }}
          />
        </CheckboxDiv>

        <CheckboxDiv
          className={
            genderPreference === 'menonly'
              ? 'checked'
              : genderPreferenceError
                ? 'error-border'
                : ''
          }
          onClick={() => handleDivGenderPreferenceChange('menonly')}
        >
          <Checkbox
            type="radio"
            name="genderPreference"
            id="genderPreference-menonly"
            className={genderPreference === 'menonly' && 'checked'}
            value={'menonly'}
            checked={genderPreference === 'menonly'}
            onChange={(e) => handleGenderPreferenceChange(e)}
          />
          <CustomSubtitle
            bold={genderPreference === 'menonly'}
            size="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[22]}`,
            }}
          />
        </CheckboxDiv>

        {/* Location */}
        <CustomSubtitle
          bold
          size="22px"
          margin="55px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[50]}`,
          }}
        />
        <CustomSubtitle
          size="18px"
          margin="0 0 16px 0px"
          weight="400"
          dangerouslySetInnerHTML={{
            __html: `${pageText[51]}`,
          }}
        />

        {/* Country */}
        <CustomSubtitle
          bold
          size="18px"
          margin="0 0 6px 0px"
          dangerouslySetInnerHTML={{
            __html: pageText2[16],
          }}
        />
        <CustomSelect
          width="-webkit-fill-available"
          placeholder={pageText2[17]}
          defaultValue={{
            value: countrySelected,
            label: country !== undefined ? country : pageText2[32],
          }}
          value={countrySelected}
          className={countryError && 'error-border'}
          isDisabled={true}
          isLoading={false}
          isClearable={true}
          isRtl={false}
          isSearchable={true}
          name="country"
          options={countriesNice}
          onChange={(e) => updateCountry(e)}
        />
        {/* Town */}
        {!isNewCity ? (
          <div>
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 6px 0px"
              dangerouslySetInnerHTML={{
                __html: pageText2[18],
              }}
            />
            <CustomSelect
              width="-webkit-fill-available"
              margin="0 0 10px"
              placeholder={pageText2[19]}
              defaultValue={'Select..'}
              className={cityError && 'error-border'}
              isDisabled={false}
              isLoading={false}
              isClearable={true}
              isRtl={false}
              isSearchable={true}
              name="town"
              options={cities}
              value={
                cityInput === ''
                  ? pageText2[32]
                  : {
                      label: cityInput,
                      value: citySelect,
                    }
              }
              onChange={(e) => updateCity(e)}
            />
          </div>
        ) : (
          <div>
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 6px 0px"
              dangerouslySetInnerHTML={{
                __html: pageText2[33],
              }}
            />
            <CustomInput
              id="city"
              type="text"
              name="town"
              margin="0 0 10px"
              className={cityError && 'error-border'}
              placeholder={pageText2[34]}
              value={cityInput}
              onChange={(e) => updateCity(e.target.value)}
            />
          </div>
        )}
        <CustomCheckboxWrapper onClick={(e) => updateIsNewCity(e.target)}>
          <CustomCheckboxForm onClick={(e) => updateIsNewCity(e.target)}>
            {isNewCity && <img src="/images/check-icon.svg" />}
          </CustomCheckboxForm>
          {pageText2[20]}
        </CustomCheckboxWrapper>

        {/* LANGUAGES */}
        <CustomSubtitle
          bold
          size="22px"
          margin="55px 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[15]}`,
          }}
        />
        <CustomSubtitle
          bold
          size="18px"
          margin="0 0 11px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[16]}`,
          }}
        />

        <FormSelect
          width="100%"
          id="languages"
          name="languages"
          className={languagesError && 'error-border'}
          isDisabled={false}
          isLoading={false}
          isClearable={false}
          isRtl={false}
          isSearchable={true}
          options={languagesOptions}
          required
          onChange={handleLanguageChange}
          isMulti
          defaultValue={defaultLanguages}
        />

        <FormContent>
          {loading ? (
            <LoadingButton padding="9px 10px">{pageText[17]}</LoadingButton>
          ) : (
            <ActionButtons type="submit" padding="9px 10px">
              {pageText[17]}
            </ActionButtons>
          )}
        </FormContent>

        <ErrorWrapper>{error && <Error error={error} />} </ErrorWrapper>
      </form>
    </ContainerBox>
  )
}

export default withRouter(withSearch(withAuth(EditProfileApp)))
